import { lazy, Suspense } from 'react';

import WidgetLoading from 'common/components/widget/WidgetLoading';

const LoadableComponent = lazy(() => import('./SubscribeWidget'));

const SubscribeWidgetRoot = (props) => (
  <Suspense fallback={<WidgetLoading />}>
    {/* eslint-disable-next-line */}
    <LoadableComponent {...props} />
  </Suspense>
);

export default SubscribeWidgetRoot;
